import { render, staticRenderFns } from "./myinfo-email.vue?vue&type=template&id=b9a44422&"
import script from "./myinfo-email.vue?vue&type=script&lang=js&"
export * from "./myinfo-email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports